/* eslint-disable no-undef */
import { createSlice } from "@reduxjs/toolkit";

const spacerStylesSlice = createSlice({
  name: "spacerStyles",
  initialState: {
    columnColors: [],
    rowColors: [],
    // TODO: color name is not recorded so stylesheet change will break spacer colors!
  },
  reducers: {
    updateSpacerColor: (state, action) => {
      const { type, index, color } = action.payload;
      if (type === "column") {
        state.columnColors[index] = color;
      } else if (type === "row") {
        state.rowColors[index] = color;
      }
    },
    onChange: (state, action) => {
      if (action.payload.columnIndexRemoved !== undefined) {
        const index = action.payload.columnIndexRemoved;
        if (index >= 0 && index < state.columnColors.length) {
          state.columnColors.splice(index, 1);
        }
      }

      if (action.payload.rowIndexRemoved !== undefined) {
        const index = action.payload.rowIndexRemoved;
        if (index >= 0 && index < state.rowColors.length) {
          state.rowColors.splice(index, 1);
        }
      }

      if (action.payload.columnIndexAdded !== undefined) {
        const index = action.payload.columnIndexAdded;
        state.columnColors.splice(index + 1, 0, "transparent");
      }

      if (action.payload.rowIndexAdded !== undefined) {
        const index = action.payload.rowIndexAdded;
        state.rowColors.splice(index + 1, 0, "transparent");
      }
    },
    reset: (state, action) => {
      return { ...action.payload };
    },
  },
});

export const { updateSpacerColor, onChange, reset } = spacerStylesSlice.actions;

export default spacerStylesSlice.reducer;
